/**
 * State used in rendering DataGridHeaderCell
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
